/* KB Stores: bloque de confianza junto al boton de compra (solo pagina de producto) */
(function () {
  function addTrust() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.kb-ptrust')) return;
    var form = document.querySelector('.product-single__meta form[action*="/cart/add"]');
    if (!form) return;
    var ul = document.createElement('ul');
    ul.className = 'kb-ptrust';
    ul.innerHTML =
      '<li><strong>Envío el mismo día</strong> en Santo Domingo en pedidos antes de las 2:00 p. m.</li>' +
      '<li><strong>Envíos a todo el país</strong> en 2 a 3 días laborables.</li>' +
      '<li><strong>Pago seguro</strong> con Visa, Mastercard y American Express.</li>';
    form.parentNode.insertBefore(ul, form.nextSibling);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addTrust);
  } else {
    addTrust();
  }
})();
